import { render } from "./EnergizingCharacteristics.vue?vue&type=template&id=61ddcece"
import script from "./EnergizingCharacteristics.vue?vue&type=script&lang=js"
export * from "./EnergizingCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script